import React from "react";
import { RequestFeedbackFilter } from "@/services/interfaces/IFeedbackService";
import RoomFilter from "./room";
import ServiceFilter from "./service";
import StaffFilter from "./staff";
import CreatedAtFilter from "./date";
import RatingFilter from "./rating";

export interface RequestFeedbacksFilterProps {
  filters: Omit<RequestFeedbackFilter, "sortBy" | "page" | "limit" | "hotelId">;
  onChange: (
    newFilters: Omit<
      RequestFeedbackFilter,
      "sortBy" | "page" | "limit" | "hotelId"
    >,
  ) => void;
}

const RequestFeedbacksFilters: React.FC<RequestFeedbacksFilterProps> = ({
  filters,
  onChange,
}) => {
  return (
    <div className="flex flex-wrap gap-4">
      <CreatedAtFilter
        range={{
          from: filters.feedbackStartDateRange,
          to: filters.feedbackEndDateRange,
        }}
        onChange={(range) =>
          onChange({
            ...filters,
            feedbackStartDateRange: range.from,
            feedbackEndDateRange: range.to,
          })
        }
      />

      <RatingFilter
        onChange={(rating) =>
          onChange({ ...filters, minRating: parseInt(rating) })
        }
        rating={filters.minRating?.toString() || "1"}
      />

      <RoomFilter
        onChange={(ids) => onChange({ ...filters, roomIds: ids })}
        ids={filters.roomIds || []}
      />

      <ServiceFilter
        onChange={(ids) => onChange({ ...filters, serviceIds: ids })}
        ids={filters.serviceIds || []}
      />

      <StaffFilter
        onChange={(ids) => onChange({ ...filters, staffIds: ids })}
        ids={filters.staffIds || []}
      />
    </div>
  );
};

export default RequestFeedbacksFilters;
